<template>
	<div class="appointment-purpose">
		<p class="body20-light">
			{{ $t("purpose.intro_text") }}
		</p>

		<p class="body20-bold">{{ $t("purpose.selection_text") }}</p>

		<div class="purpose-options">
			<div v-for="purpose in purposes" :key="purpose.id" class="purpose-option"
				:class="{ selected: selectedPurposeId == purpose.id }" @click="selectPurpose(purpose)">
				<div class="purpose-image">
					<img :src="purpose.image" :alt="purpose.name" />
				</div>
				<div class="purpose-content">
					<div class="legend16-bold">{{ purpose.category }}</div>
					<h3 class="body24-bold">{{ purpose.name }}</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { translate } from "../utils/translation.js";

export default {
	name: "AppointmentPurpose",

	props: {
		purposes: {
			type: Array,
			required: true,
		},
		currentAppointment: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			selectedPurposeId: null,
		};
	},

	created() {
		// Seleziona automaticamente il purpose se esiste un appuntamento in modifica
		this.initializeFromCurrentAppointment();
	},

	watch: {
		// Reagisci ai cambiamenti di currentAppointment nel caso venga caricato dopo
		// che il componente è già stato creato
		currentAppointment: {
			handler: "initializeFromCurrentAppointment",
			immediate: true,
		},
	},

	methods: {
		initializeFromCurrentAppointment() {
			if (this.currentAppointment) {
				// Imposta il purpose ID dall'appuntamento esistente
				this.selectedPurposeId = this.currentAppointment.purpose.id;

				// Trova l'oggetto purpose completo per emetterlo al parent
				const selectedPurpose = this.purposes.find(
					(purpose) => purpose.id == this.selectedPurposeId
				);

				if (selectedPurpose) {
					this.$emit("select-purpose", selectedPurpose);
				}
			}
		},

		selectPurpose(purpose) {
			this.selectedPurposeId = purpose.id;
			this.$emit("select-purpose", purpose);

			// Emetti un evento per avanzare automaticamente allo step successivo
			this.$nextTick(() => {
				this.$emit("proceed-next");
			});
		},
	},
};
</script>
